export default __webpack_public_path__ + "static/media/sd-upcomingevents-banner1.80a1a60e.jpg";